module.exports = __webpack_public_path__ + "static/img/hair_07.9a0a396.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_07.png
// module id = NGU5
// module chunks = 0